import { createFileRoute } from '@tanstack/react-router';

import { Dashboard } from '~/modules/dashboard';

import { i18n } from '~/utils';
import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';
import { getRouteHead } from '~/utils/routeUtils';

import { routeParams } from './-routeParams';

const title = i18n.t(($) => $.deliveries.pageTitle, { ns: 'analytics' });

export const Route = createFileRoute('/(main)/analytics/deliveries/')({
  beforeLoad: createProtectedRoute({
    routePath: '/analytics/deliveries',
    ...routeParams,
  }),
  component: Dashboard,
  head: () => getRouteHead(title),
  staticData: {
    AppBar: {
      title,
    },
  },
});

export const ANALYTICS_DELIVERIES = buildRouteExport({ Route, ...routeParams });
